"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:7.0.0'] && _();
}
catch (e) { }
